import { Row, HeadingCell, Cell } from './BillingInfoTable.styles'
import BillingInfoTable from './BillingInfoTable'

export default Object.assign(BillingInfoTable, {
  Row,
  HeadingCell,
  Cell,
})
